import styled from "@emotion/styled";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { Box, useTheme } from "@kaltura/mediaspace-shared-styled";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";
import { HeaderLogo, LogoSize } from "../header";
import type { HeaderMenuProps } from "../header";

const StyledHeaderContainer = styled(
    Box,
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "isMobile";
        },
    }
)<{ isMobile: boolean }>(({ theme, isMobile }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.kaltura.palette.surfaces.protection,
    padding: theme.spacing(isMobile ? 2 : 3, 0),
}));

export type HeaderLogoOnlyProps = Pick<HeaderMenuProps, "logo">;

/**
 * Site Header component that only displays the logo.
 */
export const HeaderLogoOnly = (props: HeaderLogoOnlyProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const logoSize: LogoSize = isMobile ? LogoSize.small : LogoSize.large;

    return (
        <ButtonAnalyticsProvider location={"header"}>
            <StyledHeaderContainer isMobile={isMobile}>
                <HeaderLogo {...props.logo} size={logoSize} minimize={false} />
            </StyledHeaderContainer>
        </ButtonAnalyticsProvider>
    );
};
